import { Link } from 'react-router-dom';
import { features } from '@/mocks/homeData';
import { useInView } from '@/hooks/useInView';

export default function FeatureSection() {
  const { ref, isInView } = useInView();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div
        ref={ref}
        className={`px-4 md:px-6 transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="max-w-[1200px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            <div className="flex-1">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                为什么选择我们
              </span>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading leading-tight">
                打造极致
                <span className="text-primary-600">韩漫阅读</span>
                体验
              </h2>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-lg">
                韩漫在线不断创新阅读方式，为漫画爱好者提供最佳的<strong>免费韩国漫画</strong>阅读平台。
                从内容资源到阅读体验，每个细节都精心打磨。
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                {features.map((feature) => (
                  <div key={feature.id} className="flex gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${feature.icon} text-lg text-primary-600`}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 font-heading">{feature.title}</h3>
                      <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-1 flex gap-4">
              <div className="flex-1 pt-8">
                <div className="rounded-xl overflow-hidden border border-background-200/70">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20Korean%20manhwa%20webtoon%20page%20with%20vertical%20scrolling%20layout%2C%20clean%20modern%20UI%2C%20colorful%20comic%20art%20style%2C%20minimal%20interface%2C%20soft%20lighting%20on%20device%20screen%2C%20isolated%20on%20clean%20light%20background%2C%20professional%20product%20photography&width=400&height=700&seq=feature-phone-01&orientation=portrait"
                    alt="韩漫在线手机阅读界面"
                    className="w-full h-auto"
                    title="韩漫在线 - 下拉式阅读手机端体验"
                  />
                </div>
              </div>
              <div className="flex-1">
                <div className="rounded-xl overflow-hidden border border-background-200/70">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20tablet%20device%20displaying%20a%20Korean%20comic%20manhwa%20reading%20interface%20with%20library%20grid%20of%20colorful%20comic%20covers%2C%20modern%20minimal%20design%2C%20warm%20ambient%20lighting%2C%20clean%20professional%20shot%2C%20isolated%20on%20light%20neutral%20background&width=400&height=700&seq=feature-phone-02&orientation=portrait"
                    alt="韩漫在线漫画库浏览界面"
                    className="w-full h-auto"
                    title="韩漫在线 - 漫画库浏览体验"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}